import AssetFull from './AssetFull';

export default AssetFull;
